import { FC } from "react";
import { useCalcPriceQuery } from "../../../api/queries/priceQueries";
import BookingStateValueInfo from "../../../components/booking/BookingStateValueInfo";
import Icon from "../../../components/image/Icon";
import { icDelete2, icEdit2 } from "../../../components/image/image-src";
import { useNaviProduct } from "../../../hooks/useNaviProduct";
import { mappingBookingState2RequestDTO } from "../../../mapping/mappingBookingState2RequestDTO";
import { useTranslationEx } from "../../../hooks/useTranslationEx";

export const CartRowInfo: FC<{
  bookingState: BookingState;
  vari: "READONLY" | "EDIT";
  setDelSingle?: (id: string) => void;
}> = ({ bookingState, vari, setDelSingle }) => {
  const { naviProduct } = useNaviProduct();
  const bookingPrice = useCalcPriceQuery([
    mappingBookingState2RequestDTO(bookingState),
  ]);
  const { t2 } = useTranslationEx();

  const priceOfBooking = bookingPrice.data?.priceOfSingleBookings?.[0];
  return (
    <div className="flex gap-5">
      <div className="wei-1 w-[6.25rem]">
        <img
          onClick={() => naviProduct(bookingState.product)}
          className="h-[6.25rem] w-[6.25rem] rounded-lg object-cover"
          src={bookingState.product?.thumbnail}
          alt=""
        />
        <div className="mt-3 flex justify-center gap-[0.9375rem]">
          <button
            type="button"
            className="size-5"
            onClick={() =>
              naviProduct({
                ...bookingState.product,
                params: {
                  bookingId: bookingState.id ?? "",
                },
              })
            }
          >
            <Icon className="mx-auto" src={icEdit2} />
          </button>
          <button
            type="button"
            className="size-5"
            onClick={() => {
              if (bookingState.id) {
                setDelSingle?.(bookingState.id!);
              }
            }}
          >
            <Icon className="mx-auto" src={icDelete2} />
          </button>
        </div>

        {vari === "EDIT" && (
          <button
            onClick={() =>
              naviProduct({
                ...bookingState.product,
                params: {
                  bookingId: bookingState.id ?? "",
                },
              })
            }
            type="button"
            className="mx-auto mt-2 flex h-[1.375rem] items-center text-center text-sm font-semibold leading-[1.375rem] text-[#007AFF] underline"
          >
            Edit
          </button>
        )}
      </div>
      <div>
        <p className="text-base font-semibold text-[#232323]">
          {[t2(bookingState.product?.name), t2(priceOfBooking?.pakage?.name)]
            .filter(Boolean)
            .join(" - ")}
        </p>
        <BookingStateValueInfo vari="CART" booking={bookingState} />
      </div>
    </div>
  );
};
